import { useEffect } from "react";

/**
 * Hand-rolled SEO/head manager. No external dep — just mutates document
 * meta tags as routes mount. Cleans up nothing on unmount because the
 * next page will overwrite the same tags.
 */
function setMeta(name, content, attr = "name") {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setLink(rel, href) {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

function setJsonLd(id, data) {
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
}

export default function SEO({
    title,
    description,
    canonical,
    ogImage,
    ogType = "website",
    twitterCard = "summary_large_image",
    jsonLd,
}) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            setMeta("description", description);
            setMeta("og:description", description, "property");
            setMeta("twitter:description", description);
        }
        if (title) {
            setMeta("og:title", title, "property");
            setMeta("twitter:title", title);
        }
        setMeta("og:type", ogType, "property");
        setMeta("twitter:card", twitterCard);
        if (ogImage) {
            setMeta("og:image", ogImage, "property");
            setMeta("twitter:image", ogImage);
        }
        const url = canonical || (typeof window !== "undefined" ? window.location.href : "");
        if (url) {
            setMeta("og:url", url, "property");
            setLink("canonical", url);
        }
        if (jsonLd) {
            setJsonLd("mm-jsonld-page", jsonLd);
        }
    }, [title, description, canonical, ogImage, ogType, twitterCard, jsonLd]);

    return null;
}
